import ProductDescription from './ProductDescription'

const BSWholeWheatPitaBreadProduct = {
  ...ProductDescription,
  category: '16',
  subCategory: '012BS',
  IsBroadband: false,
  Size: '',
}

export default BSWholeWheatPitaBreadProduct
